var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 18.9471C13.52 18.9419 15.5953 18.2299 17.1168 16.7405C15.7898 16.1805 14.4086 15.7772 13.1932 14.9875V13.3978C14.5645 12.157 14.6896 11.9265 15.0086 10.1006C15.1312 10.0051 15.2572 9.90701 15.3679 9.82078C15.4236 9.16119 15.4767 8.53845 15.5297 7.91402C15.3807 7.8144 15.2633 7.73627 15.1562 7.6645C15.2861 4.92524 13.25 3.74233 11.4697 3.71707L11.4639 3.7168H11.4583C9.67779 3.74194 7.64169 4.92517 7.77179 7.6645C7.66474 7.73614 7.54728 7.81467 7.39805 7.91402C7.45104 8.53821 7.50416 9.16091 7.56012 9.82078C7.67082 9.90701 7.79679 10.0051 7.91939 10.1006C8.23866 11.9266 8.36369 12.157 9.73508 13.3978V14.9875C8.5194 15.7776 7.138 16.1805 5.81152 16.7405C7.33333 18.2299 9.40844 18.9418 11.4586 18.9471L11.4642 18.9474C11.4662 18.9474 11.4681 18.9474 11.47 18.9471Z",
    fill: "#DBDFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9946 9.62786C21.3919 3.22712 15.5219 -0.872219 9.57413 0.158238C4.95541 0.958002 1.69933 4.93163 1.32874 7.89428C1.6768 8.30072 1.96846 8.64135 2.2857 9.01183C3.38512 3.32286 8.73419 0.645335 12.9809 1.41247C17.3938 2.21009 20.3225 5.89762 20.6007 9.6281H19.7315L21.2994 11.2006L22.8673 9.6281L21.9946 9.62786Z",
    fill: "#DBDFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.87191 11.3717C1.47434 17.7725 7.34462 21.8718 13.2924 20.8417C17.9111 20.0416 21.1672 16.0679 21.5378 13.1056C21.1897 12.6989 20.8981 12.3586 20.5808 11.9881C19.4818 17.6771 14.133 20.3546 9.88561 19.5875C5.47277 18.7898 2.54438 15.1023 2.26618 11.3718H3.13542L1.56752 9.79932L0 11.3718L0.87191 11.3717Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/Referral.f1097f46e42475610542316b9e5f773c.svg";
export { ForwardRef as ReactComponent };